import React from "react";
import "./PageSkeleton.css";

const PageSkeleton = () => {
  return (
    <div className="wrapper">
      <div className="animated-background">
        <svg
          width="980px"
          height="898px"
          viewBox="0 0 980 898"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <title>Combined Shape Copy 2</title>
          <desc>Created with Sketch.</desc>
          <defs></defs>
          <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            opacity="1"
          >
            <path
              id="Combined-Shape-Copy-2"
              fill="#FFF"
              d="M4.57231726,58.4240539 L978.983929,58.4240539 L978.983929,110.751685 L4.57231726,110.751685 L4.57231726,58.4240539 Z
              M14.224987,85.8579575 C14.224987,93.1546446 20.1407061,99.066874 27.4381154,99.066874
              L503.458722,99.066874 C510.767558,99.066874 516.671851,93.1530407 516.671851,85.8579575
              C516.671851,78.5612703 510.756132,72.649041 503.458722,72.649041
              L27.4381154,72.649041 C20.1292799,72.649041 14.224987,78.5628743 14.224987,85.8579575 Z
              M4.57231726,128.532919 L978.983929,128.532919 L978.983929,769.673406
              L4.57231726,769.673406 L4.57231726,128.532919 Z"
            />
          </g>
        </svg>
      </div>
    </div>
  );
};

export default PageSkeleton;
